import { createContext } from 'react';

const nivel5Context = createContext();

export default nivel5Context;